'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Layout_module = require('../styles/Layout.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description Container component.
 *
 * @component
 * @example
 * ```jsx
 * <Container>content</Container>
 * ```
 */
const Layout = React__namespace.forwardRef((props, ref) => {
    const { className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(Layout_module.default);
    return (React__namespace.createElement("div", { ref: ref, "data-qa": "Layout", className: cx(className, 'container'), ...restProps }, children));
});
Layout.defaultProps = {};
Layout.displayName = 'Layout';

exports.Layout = Layout;
//# sourceMappingURL=Layout.js.map
